/**
 * A fresh key for an `Idempotency-Key` header: the server treats repeated
 * requests carrying the same key as one. `crypto.randomUUID` needs a secure
 * context (https / localhost); the fallback covers anything else.
 */
export const newIdempotencyKey = (): string =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
